module.exports = __webpack_public_path__ + "static/img/dzp5.6ab8bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp5.jpg
// module id = aJHg
// module chunks = 1